import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import Checkout2 from "./Checkout2";

export default class Checkout2Modal extends BaseCom {
    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
                <Modal.Header closeButton>
                    Checkout
                </Modal.Header>
                <Modal.Body>
                    <Checkout2 currentItem={this.props.currentItem} onSuccess={this.props.onSuccess} />
                </Modal.Body>
            </Modal>
        )
    }
}